export default "__VITE_ASSET__DBEIGwy2__"